module.exports = __webpack_public_path__ + "static/media/furni4.c11eeff7.jpg";